import { FC } from "react";
import { Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

export const NotificationTimestamp: FC<{ absoluteTime: string }> = ({
  absoluteTime,
}) => {
  return (
    <Typography
      sx={{
        ...nawyTheme.nawy.typography.english.variants.body.xxs.regular,
        color: nawyTheme.nawy.colors.semantic.text.tertiary,
      }}
    >
      {absoluteTime}
    </Typography>
  );
};
